import { Col, Row } from 'antd';
import React from 'react';

import PageHeader from '@/components/PageHeader';

import { ApplicationAndManagement } from './components/ApplicationAndManagement';

const EdutainmentCategoryManagement = () => {
  return (
    <Row>
      <Col span={24}>
        <PageHeader
          title="育樂活動申請及管理"
          breadcrumbs={[
            {
              name: '育樂活動',
            },
            {
              name: '育樂活動申請及管理',
            },
          ]}
        />
        <ApplicationAndManagement />
      </Col>
    </Row>
  );
};

export default EdutainmentCategoryManagement;
